import { ITokenResponse } from '../../constants/cognito';

export async function returnCognitoResponse(response: Response): Promise<ITokenResponse> {
  const json = await response.json();
  if (json.error) {
    throw new Error(json.error);
  }
  return json;
}
